interface FormErrorProps {
	data: { errorType: string; error?: string } | null
	isBusy: string
	isValid: boolean
}

export const FormError = ({ data, isBusy, isValid }: FormErrorProps) => {
	if (!data || isBusy !== 'idle' || isValid || !data.error) {
		return null
	}

	const getErrorText = (errorType: string) => {
		switch (errorType) {
			case 'invalid_answer':
				return 'Please provide a valid answer'
			default:
				return 'Something went wrong. Please try again'
		}
	}

	return (
		<p className="-mt-3 mb-3 text-[1rem] font-bold text-error-300">
			{getErrorText(data.errorType)}
		</p>
	)
}
